import axios from 'axios';
import { auth } from '@/middleware/auth';
import router from "@/router";

const ENDPOINT = `${process.env.API_ENDPOINT}`;

/*
  Axios Request Interceptor
*/
axios.interceptors.request.use(async (request) => {
  const user = auth.getCachedSession();
  request.headers['Authorization'] = user.getIdToken().jwtToken;
  return request;
});

/*
  Handle Errors
*/

const handleError = (error) => {
  console.log(error);

  // Unknown error, log the user out
  if(typeof error.response === 'undefined'){
    router.push('/logout');
    return error;
  }

  // Check error status code
  switch (error.response.status) {
  case 401:
    router.push('/logout');
    break;
  case 404:
    router.push("/not-found");
    break;
  case 409:
  case 404:
    error.data = error;
    error.data.iserror = true;
    return error;
  case 500:
    bus.$emit("triggerAlert", {
      type: "danger",
      message: "Sorry, there was a server error. Try refreshing the page."
    });
    break;
  default:
    // unknown error
    bus.$emit("triggerAlert", {
      type: "danger",
      message: "Sorry, there was a unknown error. Try refreshing the page."
    });
    break;
  }
};

/** --------------------
 *
 *    Helper functions
 *
 * --------------------- */

const getRequest = async (url) => {
  return axios
    .get(`${ENDPOINT}${url}`)
    .catch(error => handleError(error))
    .then(res => {
      return res.data;
    });
};

const postRequest = async (url, body) => {
  return axios.post(`${ENDPOINT}${url}`, body).catch(error => handleError(error));
};

const patchRequest = async (url, body) => {
  return axios.patch(`${ENDPOINT}${url}`, body).catch(error => handleError(error));
};

const putRequest = async (url, body) => {
  return axios.put(`${ENDPOINT}${url}`, body).catch(error => handleError(error));
};

const deleteRequest = async (url) => {
  return axios.delete(`${ENDPOINT}${url}`).catch(error => handleError(error));
};

/** -----------------
 *
 *   Contract
 *
 * ----------------- */

const newQuote = () => {
  return getRequest('/new-quote').then(result => {
    return result;
  });
};

const getDeliveryMethods = (productId) => {
  let url = '/delivery-methods';
  if (productId) url 
  return getRequest('/delivery-methods').then(result => {
    return result;
  });
};

const quoteForCoordinates = (params) => {
  return postRequest('/quote-for-coordinates', params).then(result => {
    return result.data;
  });
};

const getNearestTown = (params) => {
  return postRequest('/get-nearest-towns', params).then(result => {
    return result.data;
  });
}

export {
  newQuote,
  quoteForCoordinates
};


// WEBPACK FOOTER //
// ./src/services/api.js